<script>
    import {upload} from "./upload/file_upload.service";

    const STATUS_INITIAL = 0,
        STATUS_SAVING = 1,
        STATUS_SUCCESS = 2,
        STATUS_FAILED = 3;

    export default {
        name: "BaseUploader",
        props: {},
        data() {
            return {
                uploadedResponse: {},
                uploadError: null,
                uploaderCurrentStatus: null,
                uploadFieldName: 'uploaded--file',
                uploaderUrl: null,
                uploaderAdditionalParams: null
            }
        },
        computed: {},
        methods: {
            uploaderIsInitial() {
                return this.uploaderCurrentStatus === STATUS_INITIAL;
            },
            uploaderIsSaving() {
                return this.uploaderCurrentStatus === STATUS_SAVING;
            },
            uploaderIsSuccess() {
                return this.uploaderCurrentStatus === STATUS_SUCCESS;
            },
            uploaderIsFailed() {
                return this.uploaderCurrentStatus === STATUS_FAILED;
            },
            test() {
                console.log('test')
            },
            uploaderReset() {
                // reset form to initial state
                this.uploaderCurrentStatus = STATUS_INITIAL;
                this.uploadedResponse = {};
                this.uploadError = null;
            },
            uploaderSave(formData) {
                // upload data to the server
                this.uploaderCurrentStatus = STATUS_SAVING;
                upload(formData, this.uploaderUrl)
                    .then(x => {
                        this.uploadedResponse = x;
                        this.uploaderCurrentStatus = STATUS_SUCCESS;
                    })
                    .catch(err => {
                        this.uploadError = err.response;
                        this.uploaderCurrentStatus = STATUS_FAILED;
                    });
            },
            importFilesChange(fieldName, fileList) {
                // handle file changes
                const formData = new FormData();

                if (!fileList.length) return;
                if (this.uploaderAdditionalParams) {
                    for (let params in this.uploaderAdditionalParams) {
                        if(this.uploaderAdditionalParams.hasOwnProperty(params))
                        formData.append(params, this.uploaderAdditionalParams[params]);
                    }
                }
                // append the files to FormData
                Array
                    .from(Array(fileList.length).keys())
                    .map(x => {
                        formData.append(fieldName, fileList[x], fileList[x].name);
                    });

                // save it
                this.uploaderSave(formData);
            }
        },
        mounted() {
            this.uploaderReset();
        },
    }
</script>


// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/BaseUploader.vue?84123e14